import { render } from "./AdditionalField.vue?vue&type=template&id=fbdc300e&scoped=true"
import script from "./AdditionalField.vue?vue&type=script&lang=js"
export * from "./AdditionalField.vue?vue&type=script&lang=js"

import "./AdditionalField.vue?vue&type=style&index=0&id=fbdc300e&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbdc300e"]])

export default __exports__